import type { SxProps, Theme } from "@mui/material/styles";

export type SectionHeaderAlignment = "default" | "timeline";

const timelineGridColumns = {
  xs: "1fr",
  md: "minmax(0, 1fr) 2.5rem minmax(0, 1fr)",
} as const;

export const getTitleSectionSx = (
  alignment: SectionHeaderAlignment = "default",
): SxProps<Theme> =>
  alignment === "timeline"
    ? {
        display: "grid",
        gridTemplateColumns: timelineGridColumns,
        columnGap: "1.5rem",
        rowGap: "2rem",
        alignItems: "flex-start",
      }
    : {
        flexDirection: { xs: "column", md: "row" },
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "2rem",
      };

export const getRightColumnSx = (
  alignment: SectionHeaderAlignment = "default",
): SxProps<Theme> => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
  maxWidth: { xs: "100%", md: "31.25rem", xl: "43.75rem" },
  flex: "1 1 auto",
  ...(alignment === "timeline" && {
    gridColumn: { md: "3" },
    width: "100%",
  }),
});

export const getTitleSx = (
  isDark: boolean,
  alignment: SectionHeaderAlignment = "default",
): SxProps<Theme> => ({
  color: isDark ? "#FFFFFF" : "text.primary",
  ...(alignment === "timeline" && {
    gridColumn: { md: "1" },
  }),
});

export const getDescriptionSx = (isDark: boolean): SxProps<Theme> => ({
  color: isDark ? "rgba(255, 255, 255, 0.8)" : "text.secondary",
  fontSize: "1rem",
  lineHeight: 1.6,
});
